import React, {Component, Fragment}  from 'react';
import classes from './App.module.scss';

import { Provider } from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';

import configureStore from './redux';

import AppRoute from './AppRoutes';




import axios from 'axios';
axios.defaults.baseURL = 'https://www.researchjewel.com/api/v1/';

axios.interceptors.request.use(function (config) {
  const token = store.getState().auth.token;
  if(token){
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

 const { store, persistor } = configureStore();


class App extends Component {
  render() {

    return (
      <Fragment>
      <Provider store={store}>
      <PersistGate persistor={persistor}>
      <div className={ classes.App }>
        <AppRoute store={ store } />
      </div>
      </PersistGate>
        </Provider>
        </Fragment>
    );
  }
}

export default App;
